<template lang="pug">
    v-dialog(v-model='dialog', persistent, max-width='600px')
        template(v-slot:activator='{ on }')
            v-btn.ml-2(icon v-on='on' v-if="edit" @click="importTenant(currentTenant)") 
             v-icon(small) mdi-pencil
            v-btn(outlined color="white" v-on='on' v-else) 
              v-icon.mr-2 add_circle
              | {{$t("tenant.createTitle")}}
        v-form(ref="form", v-model="valid", @submit.prevent="createTenantFunction", lazy-validation=false)
          v-card
            v-card-title {{edit  ? $t("tenant.editTitle") : $t("tenant.createTitle")}}
            v-card-text()
                  v-text-field(v-model='tenant.name', filled rounded :label='`${$t("tenant.title")} Name`')
            v-divider
            v-card-actions
                v-spacer
                v-btn(text, @click='closeDialog') {{$t("general.cancel")}}
                v-btn(color='accent', text, type="submit" :disabled="!valid")  {{edit ? $t("general.save") : $t("tenant.createTitle")}}
</template>
<script>
import validations from "@/utils/validations";
export default {
  props: ["edit", "currentTenant"],
  data() {
    return {
      dialog: false,
      showPassword: false,
      tenant: {
        name: "",
      },
      ...validations,
      valid: false,
    };
  },
  computed: {},
  methods: {
    closeDialog() {
      this.dialog = false;
      this.tenant = {
        name: "",
      };
    },
    importTenant(tenant) {
      this.tenant = {
        name: tenant.name,
        tenantId: tenant.id,
      };
    },
    async createTenantFunction() {
      if (this.edit) {
        const response = await this.$store.dispatch(
          "superAdmin/UPDATE_TENANT",
          this.tenant
        );
        if (response) this.closeDialog();
      } else {
        const response = await this.$store.dispatch(
          "superAdmin/CREATE_TENANT",
          this.tenant.name
        );
        if (response) this.closeDialog();
      }
    },
  },
};
</script>
